import { ExpandingTooltip } from "./ExpandingTooltip";

export {
  ColumnsHeader as TTColumnsHeader,
  HighlightColumns as TTHighlightColumns,
  ViewExtractedTable as TTViewExtractedTable,
  AnchorButton as TTAnchorButton,
  HardcodeButton as TTHardcodeButton,
  ColumnSuggestions as TTColumnSuggestions,
  ColumnStartLabel as TTColumnStartLabel,
  ColumnEndLabel as TTColumnEndLabel,
  ColumnName as TTColumnName,
};

// Item 63
const ColumnsHeader: ExpandingTooltip = (short) => {
  if (short)
    return <p>Configure rules to extract line-item data from the table.</p>;
  return (
    <>
      <p>
        This is where you configure specific extraction rules for each column of
        data to be extracted from the table. The column names are inherited from
        the Transact batch class. Normally, there will be an additional column
        that has been configured as a hidden column in Transact and named
        Anchor. Each column is configured independently.
      </p>
    </>
  );
};

// Item 64
const HighlightColumns: ExpandingTooltip = () => {
  return <p>Toggle to show/hide the columns on the document image. </p>;
};

// Item 65
const ViewExtractedTable: ExpandingTooltip = () => {
  return (
    <p>Toggle to show/hide the extracted data using the configured rules. </p>
  );
};

// Item 66
const AnchorButton: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Click to select the column that contains the anchor that will logically
        split the rows.
      </p>
    );
  return (
    <>
      <p>
        Click the <strong>Anchor</strong> button to select the column that
        contains the anchor that will split the rows in the table into the
        correct logical rows. The button will turn black when selected. When
        set, the rows in the table will be split into logical rows based on the
        location of the data in this anchor column. Set a column to act as the
        anchor row if the data in that column consistently appears on the top
        (anchor down) or bottom (anchor up) row of a logical row to be
        extracted. This will never be a column that can have more than one row.
      </p>
      <p>
        If none of the columns that data is to be extracted from are suitable as
        an anchor, use the column called <strong>Anchor</strong> (which you
        should set up in Transact as a hidden column) for this purpose.
      </p>
      <p>
        Once an anchor has been set, you can modify the{" "}
        <strong>anchor direction</strong>. By default, this is set to{" "}
        <strong>Downwards</strong> but if the anchor data appears at the bottom
        of the logical rows click on the selected (black) anchor button and the
        direction will change to <strong>Upwards</strong> - meaning that this
        will appear at the bottom of a logical row and anything above it will be
        included in the logical row until Accelerator finds another anchor regex
        or the table start pattern. The anchor symbol will change direction to
        indicate the anchor direction setting.
      </p>
    </>
  );
};

// Itme 67
const HardcodeButton: ExpandingTooltip = (short) => {
  if (short) return <p>Click to enter a hardcoded value for this column.</p>;
  return (
    <>
      <p>
        When a column is set to Hardcode, the hardcode value that you enter in
        the regex area for the column will always be used as the extracted value
        for every row in the table.
      </p>
    </>
  );
};

// Item 68
const ColumnSuggestions: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>Click to display optional regexes that are valid for this column.</p>
    );
  return (
    <>
      <p>
        The regex options are populated from the validation rules configured in
        Template Management.
      </p>
    </>
  );
};

// Item 69
const ColumnStartLabel: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>Use the Start slider to define the left-hand margin of the column. </p>
    );
  return (
    <>
      <p>
        Move the Start and End sliders to define the area on the page where data
        to be extracted for that column is located. If Highlight Columns has
        been selected this will be displayed as a coloured area on the image in
        the Document Viewer.
      </p>
    </>
  );
};

// Item 70
const ColumnEndLabel: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>Use the End slider to define the right- hand margin of the column. </p>
    );
  return (
    <>
      <p>
        Move the Start and End sliders to define the area on the page where data
        to be extracted for that column is located. If Highlight Columns has
        been selected this will be displayed as a coloured area on the image in
        the Document Viewer.
      </p>
    </>
  );
};

// Item 71
const ColumnName: ExpandingTooltip = (short) => {
  if (short) return <p>The column name as configured in Transact. </p>;
  return (
    <>
      <p>
        Click on a column name to display/hide that column on the document
        image. The area to the right of the column name is the editing area
        where you can add a regex. By default, the regex is set to .+ which will
        extract all data found in that column within the logical rows defined
        using the anchor row.
      </p>
    </>
  );
};
